var _circle, _circle2, _path, _circle3, _circle4, _circle5, _circle6, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "#6C5CE7",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    stroke: "#6C5CE7",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 22C28 19.79 29.79 18 32 18C34.21 18 36 19.79 36 22C36 24.21 34.21 26 32 26V30",
    stroke: "#6C5CE7",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 36,
    r: 2,
    fill: "#6C5CE7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 46,
    r: 2,
    fill: "#6C5CE7",
    opacity: 0.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 48,
    r: 2.5,
    fill: "#6C5CE7",
    opacity: 0.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 46,
    r: 2,
    fill: "#6C5CE7",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 26C50 28 51 30 51 32C51 34 50 36 48 38",
    stroke: "#6C5CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22C55 25.5 57 28.5 57 32C57 35.5 55 38.5 52 42",
    stroke: "#6C5CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQaIcon);
export default __webpack_public_path__ + "static/media/qa-icon.4e99d8c17d6844ad850cc8884cf5ba03.svg";
export { ForwardRef as ReactComponent };